<script>
import WHostPerfTable from '@/views/performance/components/virtual/HostPerfTable';
import MapAPI from '@/api/topologymap/common';

export default {
  name: 'WTopologymapHostPerfTable',
  extends: WHostPerfTable,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    loadStore() {
      if (this.active) {
        const tableParams = this.$refs.hostTable.getParameter();
        this.columns = this.logicalColumns;
        const params = {
          objDefineId: this.selectedObjDefineIds[0],
          objtypeIds: ['VHO'],
          ...tableParams,
          mapId: this.$store.getters.getCurrentMapId,
        };
        MapAPI.getPerformanceCommonListview(params).then((response) => {
          if (response.data.success) {
            this.tableDatas = response.data.data;
            this.tableTotal = response.data.total;
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/perfoper/performance/components/virtual/TopologymapHostPerfTable.vue